import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { VideoV1 } from '@ilteducation/content-registry-types';
import useUploadMedia from '@/comp/use-upload-media';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import DropFile from '@/components/base/DropFile.vue';
import authProvider from '@/data-provider/authProvider';

type Props = {
  item: VideoV1;
  market: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoUploader',
  props: {
    item: null,
    market: null
  },
  emits: ["done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'done'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: VideoV1;
  market: string;
}



const dropFileRef = ref<InstanceType<typeof DropFile> | null>(null);
const file = ref<File>();

const { uploadInProgress, upload: uploadMedia } = useUploadMedia();

const upload = async () => {
  if (!file.value) return;
  await uploadMedia(props.item.id, file.value, {
    subType: 'video',
    market: props.market,
    uploadedBy: authProvider.getName(),
  });
  dropFileRef.value?.clearFiles();
  emit('done');
};

const updateFile = (dataFiles: File[]) => {
  file.value = dataFiles[0];
};

const uploadDisabled = computed(() => !file.value);

return { __sfc: true,emit, dropFileRef, file, uploadInProgress, uploadMedia, props, upload, updateFile, uploadDisabled, DisableableButton, DropFile }
}

})